import { Callback1 } from '@deqo/foundation';
import React, { useEffect, useMemo, useState } from 'react';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { useResolve } from '../../Container';
import { Hangout } from '../Hangout';
import { HangoutUser } from '../HangoutUser';

export type HangoutUserObserverProps = {
    userId: string,
    render: Callback1<JSX.Element, HangoutUser>,
};

export const HangoutUserObserver = React.memo<HangoutUserObserverProps>(({ userId, render }) => {
    const { users } = useResolve(Hangout);
    const [target, setTarget] = useState<HangoutUser>(users.get(userId));

    useEffect(() => {
        if (!!target) return;
        return users.observe(() => {
            const latest = users.get(userId);
            if (latest !== target) {
                setTarget(latest);
            }
        });
    }, [userId, target]);

    useObserver(target);
    return render(target ?? null);
});

export const useHangoutUser = (userId: string) => {
    const hangout = useResolve(Hangout);
    useObserver(hangout.users);
    return hangout.users.get(userId);
};

export const useOnlineUsers = () => {
    const hangout = useResolve(Hangout);

    const [ticker, setTicker] = useState(0);
    useEffect(() => hangout.on('clientJoin', () => setTicker(x => x + 1)), []);
    useEffect(() => hangout.on('clientLeave', () => setTicker(x => x + 1)), []);

    return useMemo(() => hangout.users.filter(x => x.clients.size > 0), [ticker]);
};


